export const PROJECT_STAGE_COLORS: Record<string, string> = {
  'project-creator': '#42A5F5',
  created: '#1E88E5',
  meeting: '#1565C0',
  estimate: '#FBC02D',
  planning: '#80cbc4',
  negotiations: '#F9A825',
  won: '#43A047',
  'before-realization': '#81C784',
  realization: '#FB8C00',
  approved: '#8E24AA',
  payment: '#6A1B9A',
  finished: '#9E9E9E',
  complaint: '#78909C',
  lost: '#E53935',
  'before-execution': '#4DB6AC'
};
